import { FormattedMessage } from 'react-intl';
import { useLocale } from '../../configuration/lang/langSlice';
import { useRef } from 'react';
import useOnScreen from '@rio-cloud/rio-uikit/hooks/useOnScreen';
import { useAdvertisementSeen } from '../../hooks/useAdvertisementSeen';
import { gaPush, TRACKING_CATEGORIES } from '../../configuration/setup/googleAnalytics';
import { Link } from 'react-router';
import { getShortLocale } from '../../hooks/useTranslations';
import NotBookedState from '@rio-cloud/rio-uikit/components/states/NotBookedState';

export const UpsellingView = () => {
    const ref = useRef(null);
    const inView = useOnScreen(ref);
    const locale = useLocale() ?? 'en-GB';

    useAdvertisementSeen(inView);

    return (
        <div ref={ref}>
            <NotBookedState
                headline={<FormattedMessage id='intl-msg:chat.notBooked.headline' />}
                message={<FormattedMessage id='intl-msg:chat.notBooked.message' />}
                features={[
                    <FormattedMessage id='intl-msg:chat.notBooked.feature1' key='feature1' />,
                    <FormattedMessage id='intl-msg:chat.notBooked.feature2' key='feature2' />,
                    <FormattedMessage id='intl-msg:chat.notBooked.feature3' key='feature3' />,
                ]}
                outerClassName='border-none padding-0'
                condensed
            >
                <div className='padding-bottom-15 margin-top--20 text-wrap-balance '>
                    <FormattedMessage
                        id='intl-msg:chat.notBooked.learnMore'
                        values={{
                            b: chunk => <span className='text-bold'>{chunk}</span>,
                            l: chunk => (
                                <Link
                                    to={`https://rio.cloud/${getShortLocale(locale)}/marketplace/produkt/order-communication`}
                                    target='_blank'
                                    className='text-bold text-decoration-underline hover-text-decoration-none underline-offset-3'
                                    onClick={() => {
                                        gaPush({
                                            category: TRACKING_CATEGORIES.UPSELLING,
                                            action: 'Learn more',
                                            label: 'Clicked learn more link in upselling advertisement',
                                        });
                                    }}
                                >
                                    {chunk}
                                </Link>
                            ),
                        }}
                    />
                </div>

                <iframe
                    className='buyButton'
                    src={`https://buybutton.marketplace.rio.cloud/?productId=RIO-SKU00000094&level=14&locale=${locale}&internalCampaign=upselling-chat-widget-OrderCommunication`}
                    title='Upselling'
                />
            </NotBookedState>
        </div>
    );
};
